import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-xl">
              <i className="ri-movie-2-line" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              漂亮的保姆
            </span>
          </div>
          <p className="text-sm leading-relaxed text-background-300">
            专注影视剧资讯、剧情介绍与解析，为观众提供系统化的剧集信息、演员资料与最新影视动态。
          </p>
          <div className="flex items-center gap-3 mt-5">
            {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"].map(
              (icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer text-lg"
                  aria-label="社交媒体"
                >
                  <i className={icon} />
                </span>
              ),
            )}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
            <span>站点导航</span>
          </h4>
          <ul className="space-y-2 text-sm">
            {[
              { to: "/", label: "首页" },
              { to: "/news", label: "影视资讯" },
              { to: "/actors", label: "演员介绍" },
              { to: "/about", label: "关于我们" },
              { to: "/search", label: "搜索" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
            <span>剧集分类</span>
          </h4>
          <ul className="space-y-2 text-sm">
            {categories.map((c) => (
              <li key={c.type}>
                <Link
                  to={`/category/${c.type}`}
                  className="text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
            <span>联系我们</span>
          </h4>
          <ul className="space-y-3 text-sm text-background-300">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5" />
              <span>contact@pretty-nanny.example</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-phone-line mt-0.5" />
              <span>400-000-0000（工作日 9:00 - 18:00）</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5" />
              <span>上海市 · 影视文化产业园</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <span>© 2025 漂亮的保姆 · 保留所有权利</span>
          <span className="flex items-center gap-4">
            <span>本网站内容为前端演示数据，仅用于展示</span>
            <Link to="/about" className="hover:text-accent-400 cursor-pointer">
              免责声明
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}